// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__WCrEb","wrapper":"footer_wrapper__0-97o","list":"footer_list__y4ve3","item":"footer_item__fy4jW","link":"footer_link__a8YfZ"};